// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"531":"testimonials","806":"user","883":"shop","964":"product"}[chunkId] + "." + {"531":"b78bce6b","806":"39cba0a4","883":"dac13af2","964":"6ae13b3a"}[chunkId] + ".js";
};